<template>
  <div class="page page-services container is-fluid">
    <div class="container container-inner">
      <div class="columns is-gapless is-multiline">

        <div class="column content is-hidden-tablet" style="margin-top:0;padding-top:0;" data-aos="fade-up" data-aos-once="true" v-if="services">
          <img :src="services.image ? services.image.path : ''" class="img-responsive" />
        </div>

        <div class="column content content-main is-right" data-aos="fade-up" data-aos-once="true" data-aos-delay="300" v-if="services">
          <div class="title">
            {{ services.title }}
          </div>
          <markdown v-if="services.content" :source="services.content" />
          <!-- <div class="text">
            <ul>
              <li>Misdemeanor Probation Supervision</li>
              <li>Supervision of Conditional Discharge, Pre-Trial and Bond cases</li>
              <li>Corporation is bonded and insured up to $1,000,000</li>
              <li>Collections of fines,  fees and restitution at no cost to the courts</li>
              <li>Drug Screening</li>
              <li>Attend all court sessions</li>
              <li>Schedule jail time for clients</li>
              <li>Provide information regarding employment in community as needed to clients</li>
              <li>Provide information for counseling, treatment, benefit programs, etc. as needed</li>
              <li>Provide forms required for each individual court to include court sentencing orders, modifications, warrants and revocations</li>
              <li>Prepare all necessary paperwork required for every case assigned to include delinquent reports, revocation petitions, modifications, and confer with court clerks for scheduling of any hearings required</li>
              <li>Provide collections reports as required (weekly, monthly) to courts which contains the status of each client</li>
              <li>Provide quarterly statistical reports to courts to include all quarterly fines and fees collected, active and warrant status cases, new cases received, closed cases and reasons for closure, and community service hours completed</li>
              <li>Provide annual statistical reports to governing authorities of the court</li>
              <li>Professional customer service to courts and clients placed on probation</li>
              <li>Outreach services/provide assignments  to non-profit organizations in community for completion  of community service hours</li>
              <li>In accordance with O.C.G.A § 42-8-107 , all probation officers employed by CMS  "shall be at least 21 years of age at the time of appointment to the position of private probation officer or probation officer and shall have completed a standard two-year college course or have four years of law enforcement experience"</li>
              <li>Any additional services as needed or required by your court</li>
            </ul>
          </div> -->
        </div>

        <div class="column content" style="margin-top:0;padding-top:0;" data-aos="fade-up" data-aos-once="true" v-if="services && note">
          <img :src="services.image ? services.image.path : ''" class="img-responsive is-hidden-mobile" />
          <div class="box color-gray-lighter-bg">
            <markdown v-if="note.content" :source="note.content" />
            <!-- <div class="subtitle" style="margin-bottom:0.8em;">
              Collection and Probation Services
            </div> -->
            <!-- <div class="text">
              For those in need of a Spanish speaking representative we have an associate available for you. Para aquellos que necesiten un representante que hable español tenemos un representante  disponible para asistirlo.
            </div> -->
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Markdown from 'vue-markdown'
import EventBus from '@/controllers/EventBus'

import Site from '@/apis/Site'

export default {
  name: 'page-services',
  components: {
    Markdown
  },
  data () {
    return {
      isDesktop: true,
      services: undefined,
      note: undefined
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.getServices()
    this.getNote()
  },
  methods: {
    async getServices () {
      try {
        let data
        // services
        this.services = undefined
        data = await Site.aboutNamed('services')
        if (data && data[0]) {
          data = data[0]
          this.services = data
        }
      } catch (error) {
        console.log('services error', error)
      }
    },

    async getNote () {
      try {
        let data
        // note
        this.note = undefined
        data = await Site.aboutNamed('services-note')
        if (data && data[0]) {
          data = data[0]
          this.note = data
        }
      } catch (error) {
        console.log('services error', error)
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";
@import "../styles/page.scss";

.page-services {
  .content {
    a {
      text-decoration: underline;
    }
  }
}

</style>



// WEBPACK FOOTER //
// Services.vue?64eb7a87